import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

const getPositions = ({ live = {}, upcoming = {}, completed = {} }, challengeId) => {
  const allChallenges = Object.assign(
    {},
    live.challenges,
    upcoming.challenges,
    completed.challenges
  );
  const challenge = allChallenges[challengeId] || {};

  return Object.assign({}, get('teamPositions', challenge), get('playerPositions', challenge));
};

const challengeEntryListPositionsSelector = createSelector(
  get('myChallenges'),
  (state, challengeId) => challengeId,
  getPositions
);

export default challengeEntryListPositionsSelector;
